// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-form-step-managers__add[data-v-44cb9874]{display:inline-block;color:#443fdb!important;margin-top:2.5rem;cursor:pointer}", ""]);
// Exports
module.exports = exports;
